import request from '@/utils/request2'

// 列表(主数据列表)
export function loadHighValueStoreListDataApi(data) {
  return request({
    url: 'tms-web/highValueStore/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportHighValueStoreListDataApi(data) {
  return request({
    url: 'tms-web/highValueStore/exportByPage',
    method: 'post',
    data
  })
}

// 导入
export function importHighValueStoreApi(data) {
  return request({
    url: 'tms-web/highValueStore/importData',
    method: 'post',
    data
  })
}

// 作废
export function deleteHighValueStoreApi(data) {
  return request({
    url: 'tms-web/highValueStore/delete',
    method: 'post',
    data
  })
}

// 批量作废
export function deleteBatchHighValueStoreApi(data) {
  return request({
    url: 'tms-web/highValueStore/deleteBatch',
    method: 'post',
    data
  })
}

// 查看
export function viewHighValueStoreApi(data) {
  return request({
    url: 'tms-web/highValueStore/view',
    method: 'post',
    data
  })
}
